/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var calendars_module_1 = require("./calendar/calendars.module");
var dateinput_module_1 = require("./dateinput/dateinput.module");
var datepicker_module_1 = require("./datepicker/datepicker.module");
var date_range_module_1 = require("./daterange/date-range.module");
var timepicker_module_1 = require("./timepicker/timepicker.module");
var datetimepicker_module_1 = require("./datetimepicker/datetimepicker.module");
var COMPONENT_MODULES = [
    calendars_module_1.CalendarsModule,
    dateinput_module_1.DateInputModule,
    datepicker_module_1.DatePickerModule,
    timepicker_module_1.TimePickerModule,
    date_range_module_1.DateRangeModule,
    datetimepicker_module_1.DateTimePickerModule
];
/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the Date Inputs components.
 *
 * @example
 *
 * ```ts-no-run
 * // Import the Date Inputs module
 * import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
 *
 * // The browser platform with a compiler
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 *
 * import { NgModule } from '@angular/core';
 *
 * // Import the app component
 * import { AppComponent } from './app.component';
 *
 * // Define the app module
 * _@NgModule({
 *     declarations: [AppComponent], // declare the app component
 *     imports:      [BrowserModule, DateInputsModule], // import the Date Inputs module
 *     bootstrap:    [AppComponent]
 * })
 * export class AppModule {}
 *
 * // Compile and launch the module
 * platformBrowserDynamic().bootstrapModule(AppModule);
 *
 * ```
 */
var DateInputsModule = /** @class */ (function () {
    function DateInputsModule() {
    }
    DateInputsModule = tslib_1.__decorate([
        core_1.NgModule({
            exports: COMPONENT_MODULES,
            imports: COMPONENT_MODULES
        })
    ], DateInputsModule);
    return DateInputsModule;
}());
exports.DateInputsModule = DateInputsModule;
